import { render } from "./KpiHistoryAdmin.vue?vue&type=template&id=46d9354c&scoped=true"
import script from "./KpiHistoryAdmin.vue?vue&type=script&lang=js"
export * from "./KpiHistoryAdmin.vue?vue&type=script&lang=js"

import "./KpiHistoryAdmin.vue?vue&type=style&index=0&id=46d9354c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d9354c"]])

export default __exports__